import * as React from 'react'
import Page from 'components/presenter/page/Page'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import LandingHeader from './LandingHeader'
import BannerSection from './BannerSection'
import HowItWorkSection from './HowItWorkSection'
import HowItDesignSection from './HowItDesignSection'
import PromotionSolutionSection from './PromotionSolutionSection'
import SloganSection from './SloganSection'
import FooterSection from './FooterSection'
import IntroSection from './IntroSection'
import CategorySection from './CategorySection'
import * as styles from './styles.module.css'

const LandingPage = ({location}) => {
  const { t } = useTranslation()

  return (
    <Page className={styles.page}
      location={location}
      seoMeta={{
        title: t('landing.seoTitle'),
      }}>
      <LandingHeader />
      <BannerSection />
      <IntroSection />
      <CategorySection />
      <HowItWorkSection />
      <HowItDesignSection />
      <PromotionSolutionSection />
      <SloganSection />
      <FooterSection />
    </Page>
  )
}

export default LandingPage